function applyFormCustomizations() {
    const sectionNewsletter = document.body.querySelector(".shopify-section--newsletter");
    if (sectionNewsletter) {
      document.body.querySelector(".footer__block--newsletter").style.display = "none"
    }

    // customize forms
    const STYLE_ID = "rsvp-shadow-style";
    const CSS_URL = "{{ 'forms.css' | asset_url }}";
    function injectStyleIntoShadow(wc) {
      const sr = wc.shadowRoot;
      
      console.log(sr)
      if (sr.getElementById(STYLE_ID)) return true; // already injected

      const link = document.createElement("link");
      link.id = STYLE_ID;
      link.rel = "stylesheet";
      link.href = CSS_URL;
      sr.appendChild(link);
    }

    // Handle existing embeds
    document.querySelectorAll("shopify-forms-embed").forEach(injectStyleIntoShadow);

    // Observe for future embeds
    const mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (!(node instanceof Element)) continue;
          
          if (node.matches?.("shopify-forms-embed")) {
            injectStyleIntoShadow(node);
          }
        }
      }
    });

    mo.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
}

function forceAvailabilityFilter() {
  const forceAvailabilityFields = ["filter.v.t.shopify.shoe-size"];

  document.addEventListener(
    "change",
    (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (target.type !== "checkbox") return;
      if (!forceAvailabilityFields.includes(target.name)) return;

      const facetsForm = target.closest("facets-form");
      if (!facetsForm) return;

      const availabilityInput = facetsForm.querySelector(
        'input[name="filter.v.availability"]'
      );
      if (!availabilityInput) return;

      const shouldForceAvailability = forceAvailabilityFields.some(
        (fieldName) =>
          facetsForm.querySelector(`input[name="${fieldName}"]:checked`)
      );

      if (shouldForceAvailability) {
        availabilityInput.checked = true;
      }
    },
    true // capture phase
  );
}

document.addEventListener("DOMContentLoaded", () => {
  applyFormCustomizations();
  forceAvailabilityFilter();
})